import { Stack } from "@carbon/react";
import React from "react";

type PageStackProps = {
  children: React.ReactNode;
};

// A stack to use for all pages to have the same spacing everywhere
const PageStack: React.FC<PageStackProps> = ({ children }) => {
  return <Stack gap={1}>{children}</Stack>;
};

export default PageStack;
